import { buildPath } from "@contract";
import { useTranslation } from "react-i18next";
import { useClip } from "../../../components/audio/AudioProvider";
import { Button } from "../../../components/control/Button";
import { Duration } from "../../../components/format/Duration";

/** Authenticated application URL, never an expired presigned URL cached by the UI. */
export function ChapterListen({
  bookId,
  chapterId,
  version,
}: {
  bookId: string;
  chapterId: string;
  version: string;
}) {
  const { t } = useTranslation("render");
  const url = `/api${buildPath("/books/:id/chapters/:cid/audio", { id: bookId, cid: chapterId })}?format=mp3`;
  const clip = useClip(`${chapterId}:${version}`, url);
  return (
    <span className="inline-flex flex-wrap items-center gap-1">
      <Button variant="quiet" size="sm" onClick={clip.toggle} busy={clip.status === "loading"}>
        {clip.status === "playing"
          ? t("pause")
          : clip.status === "failed"
            ? t("listenAgain")
            : t("listen")}
      </Button>
      <a
        href={`${url}&download=1`}
        className="inline-flex min-h-8 items-center rounded-sm px-2 text-accent underline hover:bg-sunken focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        {t("downloadChapter")}
      </a>
      {clip.active && clip.durationMs > 0 ? <Duration ms={clip.positionMs} /> : null}
    </span>
  );
}
